import { Box, useColorMode, VStack } from '@chakra-ui/react'
import type { IngridCreateSessionResponse } from 'ecosystem'
import { useEffect, useRef } from 'react'
import { useRefUpdated } from 'ui/hooks/useRefUpdated'
import { replaceIngridScriptNode } from './utils'

interface IngridCheckoutProps {
  ingridResponseData?: null | IngridCreateSessionResponse
  onReady?: () => void
}

export const IngridCheckout = ({ ingridResponseData, onReady }: IngridCheckoutProps) => {
  const { colorMode } = useColorMode()
  const handleIsReady = useRefUpdated(onReady)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!wrapperRef.current || !ingridResponseData?.html_snippet) {
      return
    }

    wrapperRef.current.innerHTML = ingridResponseData.html_snippet

    replaceIngridScriptNode()

    handleIsReady.current?.()
  }, [handleIsReady, ingridResponseData?.html_snippet])

  return (
    <VStack {...(colorMode === 'dark' ? { backgroundColor: '#fff', p: 2 } : {})} w="100%">
      <Box maxW="640px" ref={wrapperRef} width="100%" />
    </VStack>
  )
}
